// extracted by mini-css-extract-plugin
export default {"container":"Button_container__Vt1ZV","loader":"Button_loader__y1VGI"};